import { render, staticRenderFns } from "./editCommunityFun.vue?vue&type=template&id=3b49b2e2"
import script from "./editCommunityFun.vue?vue&type=script&lang=js"
export * from "./editCommunityFun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports